import { type MaybeRefOrGetter, toValue } from 'vue'
import type { AsyncDataRequestStatus } from '#app'

export const isDataFetching = (
  status: MaybeRefOrGetter<AsyncDataRequestStatus>,
) => {
  const statusValue = toValue(status)
  return ['idle', 'pending'].includes(statusValue)
}
